<template>
    <div>
        <div class="columns is-multiline">
            <div class="column is-one-quarter-desktop is-half-tablet"   v-for="DATA in imagesArrRecently" :key="DATA.id">
                <div  class="card" >
                    <div class="card-content   is-size-7">
                        <span class="has-text-grey control"> 
                                        <b-tooltip position="is-top" multilined>
                                        <template v-slot:content>
                                               View <b>{{DATA.idlab}}</b><br/> Full Content Data
                                        </template>
                                        <b-button size="is-small"
                                            icon-left="github-circle"
                                            @click="showLab(DATA.idlab,DATA.lab_kind_name,DATA.idopd)" >
                                        {{DATA.idlab}} 
                                        </b-button> 
                                        </b-tooltip>
                                        <span class="control">
                                              <b-tooltip position="is-top" multilined type="is-white">
                                               <template v-slot:content>
                                                Copy <b>{{DATA.idlab}}</b><br/> clipboard
                                               </template> 
                                              <b-button  size="is-small"  icon-left="content-copy" v-clipboard:copy="DATA.idlab" @click="clickCopyIntoClipboard(DATA.idlab)" />
                                              </b-tooltip>
                                        </span>
                        </span>  <br/> 


            
            
         
                        OPD No: <span class="has-text-grey">   {{DATA.idopd}}   </span>  <br>
                        OPD Name : <span class="has-text-grey">   {{DATA.opd_name}}  </span>  <br>
                        Species/Breed : <span class="has-text-grey">   {{DATA.species_name}}  /  {{DATA.breed_name}}  </span>  <br>
                        By : <span class="has-text-grey">   {{DATA.user_rec_fn}}     </span>  <br>
                        At : <span class="has-text-grey mb-3">        <span  >
                                                                    {{  getISO8601ToYearMonthDate( DATA.datetime_rec ).date }}  
                                                                    {{  getISO8601ToYearMonthDate( DATA.datetime_rec  ).month }} 
                                                                    {{  getISO8601ToYearMonthDate( DATA.datetime_rec   ).year }} 
                                                                    </span> 
                                                                        
                                                                    <span  >
                                                                        {{  getISO8601ToYearMonthDate( DATA.datetime_rec  ).hour }}:{{  getISO8601ToYearMonthDate( DATA.datetime_rec ).minute }} 
                                                                    </span>  
                            </span>  <br>
                        <template  >
                            <div class="box"  v-for="DX in DATA.dx" :key="DX.id">
                                 <span v-if="DX.unclassified_codes != null"  >Dx Unclassified :  <span class="has-text-grey">{{DX.unclassified_codes}}</span>   <br></span>
                                 <span v-if="DX.hierarchy != null" >Dx Hierarchy : <span class="has-text-grey"> {{DX.hierarchy}}</span>   </span>
                            </div>
                        </template>
                        
                    </div>


                    <div class="card-image  ">
                        <figure class="image is-4by3"  >
                        <img :src="buildFullImageUrl_FromIDLABAndPath(DATA.idlab,DATA.path)"  >
                        </figure>

                        
                    </div>


                    <footer class="card-footer">
                        <a class="card-footer-item" @click="imageModal(buildFullImageUrl_FromIDLABAndPath(DATA.idlab,DATA.path))" >
                            <b-icon
                                    icon="magnify"
                                    size="is-medium">
                            </b-icon>
                        </a>
                    
                    </footer>
                </div>




            </div>
             <div class="column">
                 <b-button type="is-primary" outlined 
                        :loading="isMoreBtnLoadingModel" 
                        class="ml-5 mt-5 mb-5"
                        @click="loadDataMore" >More..</b-button> 
             </div>
             

        </div>


        <b-modal :active.sync="isImageModalActive">
            <p class="image ">
                <img :src=dataUrl>
            </p>
        </b-modal>



    </div>
</template>


<script>
import getISO8601ToYearMonthDate from '../mixins/methods/getISO8601ToYearMonthDate'
import buildFullImageUrl_FromIDLABAndPath from '../mixins/methods/buildFullImageUrl_FromIDLABAndPath'


import { mapMutations, mapState } from "vuex";

export default {
    name : "ImagesLABNonRecently_ViewImagesSeries",
    mixins:[getISO8601ToYearMonthDate,buildFullImageUrl_FromIDLABAndPath,],
    computed:{
        ...mapState({
            imagesArrRecently : state => state.home.imagesArrRecently ,
            isMoreBtnLoading : state => state.home.isMoreBtnLoading ,
        }),
        isMoreBtnLoadingModel:{
                get: function () {
                    return this.isMoreBtnLoading
                },
                set: function (newValue) {
                    this.setIsMoreBtnLoading(newValue)
                }
        },
    },    
    methods:{
        ...mapMutations({
            setIsMoreBtnLoading : 'home/setIsMoreBtnLoading',
        }),
        loadDataMore(){
            this.isMoreBtnLoadingModel = true
            this.$emit('loadMoreDataImagesRecently')
        },
        imageModal(dataUrl){
                if(dataUrl !== "") {
                    this.dataUrl = dataUrl
                }else{
                    this.dataUrl = 'imgnotaval.jpg'
                }
                this.isImageModalActive = true
        },
        showLab(_idlab,_kind,_idopd){
         const payload =  {"idlab": _idlab ,"kind": _kind ,"idopd":_idopd}
         this.$emit('showLab',payload)
        },
        clickCopyIntoClipboard(_id){
              this.$buefy.toast.open({
                    duration: 2000,
                    message: `Copy <b>${_id}</b> to clipboard`,
                    position: 'is-bottom',
                    type: 'is-primary is-light'
                })
        },
      
    },
    data(){
       return {
        // isMoreBtnLoading : false,

        isImageModalActive : false,
        dataUrl : "",
       } 
    }
}
</script>